export default __webpack_public_path__ + "images/ZG.33bd883.png";